import React, {Component, createRef} from "react";
import styles from './FJMusicItem.module.less';
import InlineSVG from "react-inlinesvg";
import PlayIcon from '../../../../../icon/music-play.svg';
import FJCoreUtil from "../../../../../core/util/FJCoreUtil";
import FJMusicRefresh from "./FJMusicRefresh";
import SuspendIcon from '../../../../../icon/music-suspend.svg';
import FJSpinLoading from "./FJSpinLoading";
import classNames from 'classnames';
import FJUtil from "../../../../../util/FJUtil";
import FJAddButton from "../FJAddButton";
import FJMessageStore from "../../../../../store/FJMessageStore";
import FJLocalStore from "../../../../../store/FJLocalStore";
import ResizeSensor from "resize-sensor"

class FJMusicItem extends Component {

	constructor(props) {
		super(props);

		this.state = {
			imageLoaded: false,
			isPlaying: false,
			loading: false,
			audioProgress: 0,
			cursorProgress: 0,
			showTimeProgress: false,
			url: props.url + '?t=' + Date.now(),
			iRefresh: false,
		}

		this.container = createRef();
		this.contextBox = createRef();
		this.contextPreview = createRef();
		this.wavePreview = createRef();
		this.progress = createRef();
	}

	componentDidMount() {
		// this.waveImage = new Image();
		// this.waveImage.setAttribute('crossOrigin', 'anonymous');
		// FJCoreUtil.addEvent(this.waveImage, 'error', this._imageError);
		// FJCoreUtil.addEvent(this.waveImage, 'load', this._imageLoaded);
		this.resizeSensor1 = new ResizeSensor(this.container.current, this._updateUI);
		this.resizeSensor2 = new ResizeSensor(document.body, this._updateUI);
		// this.waveImage.src = this.state.url;
		this._updateUI();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		// if (prevState.url !== this.state.url) {
		// 	this.waveImage.src = this.state.url;
		// }

		if (prevProps.active !== this.props.active && !this.props.active) {
			this.init();
		}

		this._updateUI();
	}

	componentWillUnmount() {
		// FJCoreUtil.removeEvent(this.waveImage, 'error', this._imageError);
		// FJCoreUtil.removeEvent(this.waveImage, 'load', this._imageLoaded);
		this.resizeSensor1.detach();
		this.resizeSensor2.detach();
		// this.waveImage.src = '';
		// this.waveImage = null;
		this._clear();
	}

	init = () => {
		this.setState({
			isPlaying: false,
			audioProgress: 0,
		}, () => {
			if (this.audio) {
				this.pauseAudio();
				FJCoreUtil.removeEvent(this.audio, 'seeked', this._audioSeeked);
				this.audio.currentTime = 0;
			}
		});
	};

	_updateUI = () => {
		let {width} = this.contextBox.current.getBoundingClientRect();
		width -= 480;
		// this.contextKeyword.style.setProperty('width', (width * 0.34) + 'px');
		this.contextPreview.current.style.setProperty('width', (width * 0.56) + 'px');
	};

	_imageLoaded = () => {
		this.setState({
			imageLoaded: true,
			iRefresh: false,
		});
		// TODO 将音乐图片进行滤镜处理
		// let fCanvas = FJGLFilterStore.applyFilter({
		// 	filter: {
		// 		active: true,
		// 		type: 'black & white 1',
		// 		intensity: 1,
		// 	}
		// }, this.waveImage);
		// if (fCanvas) {
		// 	let width = fCanvas.width;
		// 	let height = fCanvas.height;
		// 	this.wavePreview.current.width = width;
		// 	this.wavePreview.current.height = height;
		// 	this.wavePreview.current.getContext('2d').drawImage(fCanvas, 0, 0, width, height);
		// } else {
		// 	let width = this.waveImage.naturalWidth;
		// 	let height = fCanvas.naturalHeight;
		// 	this.wavePreview.current.width = width;
		// 	this.wavePreview.current.height = height;
		// 	this.wavePreview.current.getContext('2d').drawImage(this.waveImage, 0, 0, width, height);
		// }
	};
	_imageError = () => {
		this.setState({
			iRefresh: true,
		})
	};
	_refresh = () => {
		this.setState({
			url: this.props.url + '?t=' + Date.now(),
		})
	};
	_togglePlay = () => {

		if (this.state.loading && this.state.isPlaying) {
			return;
		}

		this.setState({
			isPlaying: !this.state.isPlaying,
			showTimeProgress: true,
		}, () => {
			let {isPlaying} = this.state;
			let {previewUrl,  changeActiveItem, index } = this.props;
			if (!this.audio) {
				this.setState({loading: true});
				this.audio = new Audio(previewUrl);
				FJCoreUtil.addEvent(this.audio, 'loadeddata', this._audioLoaded);
				FJCoreUtil.addEvent(this.audio, 'error', this._audioError);
				FJCoreUtil.addEvent(this.audio, 'playing', this._audioUpdateCallback);
				FJCoreUtil.addEvent(this.audio, 'pause', this._audioPauseCallback);
				FJCoreUtil.addEvent(this.audio, 'ended', this._audioEndCallback);

				this.outTime = setTimeout(this._audioError, 30000);
			}
			if (isPlaying) {
				this.playAudio();
			} else {
				this.pauseAudio();
			}

			changeActiveItem(index);
		})
	};
	playAudio = () => {
		this.audio.play().then(() => {
			this.couldPause = true;
			if (!this.state.isPlaying) {
				this.pauseAudio();
			}
		}).catch((e) => {
			console.log(e)
		});
	};
	pauseAudio = () => {
		if (this.couldPause) {
			this.audio.pause();
		}
	};
	_clear = () => {
		if (this.audio) {
			FJCoreUtil.removeEvent(this.audio, 'loadeddata', this._audioLoaded);
			FJCoreUtil.removeEvent(this.audio, 'error', this._audioError);
			FJCoreUtil.removeEvent(this.audio, 'playing', this._audioUpdateCallback);
			FJCoreUtil.removeEvent(this.audio, 'pause', this._audioPauseCallback);
			FJCoreUtil.removeEvent(this.audio, 'ended', this._audioEndCallback);
			this.audio.src = null;
			this.audio = null;
		}
	};
	_seek = (progress) => {
		this.isSeeking = true;
		if (this.audio) {
			this.pauseAudio();
		}

		this.setState({
			audioProgress: progress,
			cursorProgress: progress,
			showTimeProgress: true,
		}, () => {
			let {changeActiveItem, index} = this.props;
			changeActiveItem(index);
		})
	};
	_audioError = () => {
		if (this.outTime) {
			clearTimeout(this.outTime);
		}
		this.init();
		this._clear();
		FJMessageStore.addMessage(FJLocalStore._('stock-audio-error'), 'warning');
	};
	_audioLoaded = () => {
		if (this.outTime) {
			clearTimeout(this.outTime);
		}
		this.setState({loading: false});
		if (this.audio && this.state.isPlaying && !this.isSeeking) {
			this.audio.currentTime = this.state.audioProgress * this.props.duration;
		}
	};
	_audioSeeked = () => {
		if (this.audio) {
			FJCoreUtil.removeEvent(this.audio, 'seeked', this._audioSeeked);
			if (this.state.isPlaying) {
				this.playAudio();
			} else {
				this.pauseAudio();
			}
		}
	};

	_mouseMoveForOver = (e) => {
		this.setState({
			cursorProgress: this._getProgressByCursor(e),
		});
	};
	_mouseDown = (e) => {
		this._seek(this._getProgressByCursor(e));
		FJCoreUtil.addEvent(this.progress.current, 'mousemove', this._mouseMove);
		FJCoreUtil.addEvent(document.body, 'mouseup', this._mouseUp);
	};
	_mouseMove = (e) => {
		this._seek(this._getProgressByCursor(e));
	};
	_mouseUp = (e) => {
		let progress = this._getProgressByCursor(e);
		this._seek(progress);
		FJCoreUtil.removeEvent(this.progress.current, 'mousemove', this._mouseMove);
		FJCoreUtil.removeEvent(document.body, 'mouseup', this._mouseUp);
		this.isSeeking = false;
		if (this.audio) {
			FJCoreUtil.addEvent(this.audio, 'seeked', this._audioSeeked);
			let time = progress * this.props.duration;
			if (isFinite(time)) {
				this.audio.currentTime = time;
			}
		}
	};
	_getProgressByCursor = (e) => {
		let {width, left} = this.progress.current.getBoundingClientRect();
		let value = (e.clientX - left) / width;
		return FJCoreUtil.valueOfInterval(value, 0, 1);
	};
	_audioUpdateCallback = () => {
		if (this.timer) {
			clearInterval(this.timer);
		}

		this.timer = setInterval(() => {
			let duration = this.props.duration;
			if (this.audio) {
				this.setState({
					audioProgress: duration === 0 ? 1 : this.audio.currentTime / duration,
				});
			}
		}, 16.7);
	};
	_audioPauseCallback = () => {
		if (this.timer) {
			clearInterval(this.timer);
		}
	};
	_audioEndCallback = () => {
		this.init(true);
	};

	_onAddClick = () => {
		const {addMusic, selected, id, name, duration} = this.props;
		addMusic(id, selected, '', {name, duration});
	}

	render() {

		let {
			width,
			height,
			name,
			duration,
			selected,
			active
		} = this.props;

		let {
			iRefresh,
			isPlaying,
			loading,
			imageLoaded,
			audioProgress,
			cursorProgress,
			showTimeProgress,
			url,
		} = this.state;

		return (
			<li style={{width: width, height: height}} className={styles.item_box} ref={this.container}>
				<div className={classNames(styles.content_box, {[styles.active]: active})} ref={this.contextBox}>
					<div className={styles.content_left}>
						<div className={classNames(styles.left_icon_box, {[styles.loading]: isPlaying && loading})}
								 onClick={this._togglePlay}>
							{
								isPlaying ? (loading ? <FJSpinLoading style={{transform: 'scale(0.6)'}}/> : <FJReturnIcon icon={SuspendIcon}/>) : <FJReturnIcon icon={PlayIcon}/>
							}
						</div>
						<div className={styles.basic_info}>
							<span className={styles.info}>
								{name}
							</span>
						</div>
					</div>
					<div className={styles.content_right}>
						<div className={styles.right_preview}>
							<div className={styles.preview_content} ref={this.contextPreview}>
								<img className={classNames(styles.audio_wave, {[styles.loaded]: imageLoaded})} 
										 src={url}
										 onLoad={this._imageLoaded}
										 onError={this._imageError}
										 ref={ele =>  this.waveImage = ele} />
							</div>
							<div onMouseDown={this._mouseDown}
									 onMouseMove={this._mouseMoveForOver}
									 ref={this.progress}
									 className={styles.audio_progress}
							>
								<i style={{width: audioProgress * 100 + '%'}} className={styles.progress_mask}/>
								<i style={{left: cursorProgress * 100 + '%'}} className={styles.audio_cursor}/>
							</div>
						</div>
						<span className={styles.bottom_info_duration}>
							{
								showTimeProgress ? FJUtil.formatTime(duration * audioProgress) + "/" + FJUtil.formatTime(duration): FJUtil.formatTime(duration)
							}
						</span>
						<FJAddButton onClick={this._onAddClick} selected={selected} className={styles.add_btn} />
					</div>
					<FJMusicRefresh active={iRefresh} refreshCallback={this._refresh}/>
				</div>
				<audio style={{display: 'none'}}/>
			</li>
		)
	}

}

function FJReturnIcon(props) {
	return (
		<div className={styles.play_icon}>
			<InlineSVG src={props.icon}/>
		</div>
	)
}

export default FJMusicItem;